module.exports={
  "name": "frequencyasia",
  "version": "1.4.0",
  "description": "Frequency Asia website",
  "main": "js/app.js",
  "scripts": {
    "test": "test"
  },
  "author": "",
  "license": "ISC",
  "devDependencies": {
    "autoprefixer": "^6.2.1",
    "babel-preset-es2015": "^6.3.13",
    "babel-preset-react": "^6.5.0",
    "babelify": "^7.2.0",
    "brfs": "^1.4.1",
    "browserify": "^12.0.1",
    "envify": "^3.4.0",
    "eslint": "^1.10.3",
    "eslint-config-airbnb": "^2.0.0",
    "eslint-plugin-react": "^3.11.3",
    "gulp": "^3.9.0",
    "gulp-cssnano": "^2.0.0",
    "gulp-if": "^2.0.1",
    "gulp-postcss": "^6.0.1",
    "gulp-rename": "^1.2.2",
    "gulp-sourcemaps": "^1.6.0",
    "gulp-stylelint": "^3.0.0",
    "gulp-uglify": "^1.5.1",
    "gulp-util": "^3.0.7",
    "lodash": "^4.0.0",
    "postcss-extend": "^1.0.5",
    "postcss-import": "^8.1.2",
    "postcss-simple-vars": "^3.0.0",
    "stylelint": "^7.0.2",
    "stylelint-config-standard": "^11.0.0",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.1.0",
    "watchify": "^3.6.1"
  },
  "dependencies": {
    "fecha": "^1.1.1",
    "i18next": "^3.4.1",
    "jquery": "^2.1.4",
    "pubsub-js": "^1.5.3",
    "react": "^15.1.0",
    "react-dom": "^15.1.0",
    "react-marquee": "^0.1.0",
    "react-router-component": "^0.32.2",
    "react-simpletabs": "^0.7.0",
    "swiper": "^3.2.7"
  }
}
